import { call, put } from "redux-saga/effects";
import { cncFetchWOStatus } from "../requests/cncFetchWOStatus";
import {
  fetchCNCManualWeborderStatusSuccess,
  fetchCNCManualWeborderStatusFailure,
  fetchCNCScannedWeborderStatusSuccess,
  fetchCNCScannedWeborderStatusFailure,
} from "../../cncWebOrder/cncWebOrderActions";
import {
  startLoadingIndicator,
  stopLoadingIndicator,
} from "../../loadingIndicator/loadingIndicatorActions";
import Constants from "../../../Constants";

export function* handleFetchCNCManualWeborderStatus({
  payload: { weborderNo },
}) {
  try {
    yield put(startLoadingIndicator());
    const response = yield call(cncFetchWOStatus, { woNo: weborderNo });
    const { woStatus, woId, woNo, pickup_store_location } =
      parseWOStatus(response);
    let lWoStatus = woStatus
      ? woStatus
      : Constants.webOrderConst.status.NotFound;
    yield put(
      fetchCNCManualWeborderStatusSuccess({
        woStatus: lWoStatus,
        woId,
        woNo,
        pickup_store_location,
      })
    );
    yield put(stopLoadingIndicator());
  } catch (error) {
    console.log(`handleFetchCNCManualWeborderStatus error = ${error}`);
    yield put(fetchCNCManualWeborderStatusFailure({ error }));
    yield put(stopLoadingIndicator());
  }
}

export function* handleFetchCNCScannedWeborderStatus({
  payload: { weborderNo },
}) {
  try {
    yield put(startLoadingIndicator());
    const response = yield call(cncFetchWOStatus, { woNo: weborderNo });
    const { woStatus, woId, woNo, pickup_store_location } =
      parseWOStatus(response);
    let lWoStatus = woStatus
      ? woStatus
      : Constants.webOrderConst.status.NotFound;
    yield put(
      fetchCNCScannedWeborderStatusSuccess({
        woStatus: lWoStatus,
        woId,
        woNo,
        pickup_store_location,
      })
    );
    yield put(stopLoadingIndicator());
  } catch (error) {
    console.log(`handleFetchCNCScannedWeborderStatus error = ${error}`);
    yield put(fetchCNCScannedWeborderStatusFailure({ error }));
    yield put(stopLoadingIndicator());
  }
}

const parseWOStatus = (resp) => ({
  woStatus: resp?.data?.data[0]?.cc_status,
  woId: resp?.data?.data[0]?.pk_document_no,
  woNo: resp?.data?.data[0]?.pk_document_no,
  pickup_store_location: resp?.data?.data[0]?.pickup_store_location,
});
